import { useState } from "react";
import { FaUser, FaPhone, FaLock, FaEye, FaEyeSlash, FaEnvelope } from "react-icons/fa";

const CustomInputIcon = ({ name, value, onChange, placeholder }) => {
    const [showPassword, setShowPassword] = useState(false);

    const isPassword = name === "password";
    const inputType = isPassword
        ? showPassword ? "text" : "password"
        : name === "email" ? "email"
        : name === "phone" ? "number"
        : "text";

    const togglePassword = () => setShowPassword(!showPassword);

    // Pilih ikon kiri sesuai field
    const getLeftIcon = () => {
        if (name === "email") return <FaEnvelope className="text-gray-600" />;
        if (name === "phone") return <FaPhone className="text-gray-600" />;
        if (name === "password") return <FaLock className="text-gray-600" />;
        return null;
    };

    return (
        <div className="relative w-full">
            <input
                name={name}
                value={value}
                onChange={onChange}
                type={inputType}
                className="pl-12 pr-10 px-4 py-2 text-[16px] w-full bg-gray-200 border border-[#00000080] rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder={placeholder}
            />

            <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
                {getLeftIcon()}
            </div>

            {isPassword && (
                <div
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer text-gray-600"
                    onClick={togglePassword}
                >
                    {showPassword ? <FaEye /> : <FaEyeSlash />}
                </div>
            )}
        </div>
    );
};

export default CustomInputIcon;
